// Shared constants used across GeneratePage, HistoryPage, and other generation flows

export const CONTENT_TYPE_CATEGORIES = [
  { label: "Social & Authority", items: ["Thought Leadership", "Diagnostic", "Authority Post", "Conversion Post", "Educational Post", "Contrarian Take", "Story Post", "Carousel"] },
  { label: "Long-Form", items: ["Newsletter Issue", "Newsletter Section", "Substack Article", "Blog Post"] },
  { label: "Lead Gen", items: ["Lead Magnet Intro", "Lead Magnet Section", "Opt-In Landing Page Copy", "Thank You Page Copy"] },
  { label: "Email", items: ["Email (Single)", "Email Sequence (Multi-Part)", "Welcome Email", "Nurture Email", "Pitch / Sales Email"] },
  { label: "Video & Audio", items: ["Short-Form Video Script", "Long-Form Video Script", "Podcast Intro / Outro", "Webinar Script Section", "Training Module Script"] },
  { label: "Sales", items: ["Sales Page Section", "VSL Script", "Case Study", "Testimonial Framework"] },
  { label: "Other", items: ["Bio / About Section", "Content Upgrade Copy", "Poll / Engagement Post", "Other"] },
];

export const ALL_CONTENT_TYPES = CONTENT_TYPE_CATEGORIES.flatMap(c => c.items);

export const CONTENT_TYPES = [
  "Thought Leadership", "Diagnostic", "Authority Post", "Conversion Post",
  "Educational Post", "Contrarian Take", "Story Post", "Carousel",
  "Newsletter Issue", "Newsletter Section", "Substack Article", "Blog Post",
  "Lead Magnet Intro", "Lead Magnet Section", "Opt-In Landing Page Copy", "Thank You Page Copy",
  "Email (Single)", "Email Sequence (Multi-Part)", "Welcome Email", "Nurture Email", "Pitch / Sales Email",
  "Short-Form Video Script", "Long-Form Video Script", "Podcast Intro / Outro",
  "Webinar Script Section", "Training Module Script",
  "Sales Page Section", "VSL Script", "Case Study", "Testimonial Framework",
  "Bio / About Section", "Content Upgrade Copy", "Poll / Engagement Post", "Lead Magnet", "Other",
];

export const PLATFORMS = [
  "LinkedIn", "Instagram", "Facebook", "X (Twitter)", "Bluesky",
  "Substack", "LinkedIn Newsletter", "Blog / Website",
  "Email List", "YouTube", "TikTok", "Podcast", "Webinar / Training",
  "Lead Magnet (PDF)", "Sales Page", "Landing Page",
];

export const GOALS = [
  "Build trust and authority", "Drive engagement and replies", "Diagnose a problem",
  "Reframe thinking", "Generate leads", "Grow email list", "Prompt opt-in",
  "Move to CTA", "Sell a product or service", "Educate and add value",
  "Warm cold audience", "Re-engage existing audience", "Other",
];

export const TONES = [
  "Direct", "Sharp", "Calm", "Contrarian", "Insightful", "Practical", "Urgent",
  "Warm", "Provocative", "Technical", "Empathetic", "Witty", "Authoritative", "Conversational",
];

export const MULTI_SECTION_TYPES = [
  "Newsletter Issue", "Newsletter Section", "Substack Article",
  "Lead Magnet Intro", "Lead Magnet Section", "Opt-In Landing Page Copy",
  "Email Sequence (Multi-Part)", "Webinar Script Section", "Training Module Script",
  "Sales Page Section", "Case Study",
];

export const NEWSLETTER_TYPES = ["Newsletter Issue", "Newsletter Section", "Substack Article"];
export const LEAD_MAGNET_TYPES = ["Lead Magnet", "Lead Magnet Intro", "Lead Magnet Section", "Opt-In Landing Page Copy", "Thank You Page Copy"];

export const LOADING_MESSAGES = [
  "Analyzing brand voice...", "Synthesizing strategy...", "Crafting the angle...",
  "Writing the draft...", "Applying quality filters...", "Polishing the output...",
];

export const STATUS_CONFIG = {
  draft: { label: "Draft", color: "bg-[var(--bg-hover)] text-[var(--text-muted)]", border: "border-[var(--border)]" },
  in_review: { label: "In Review", color: "bg-amber-500/10 text-amber-400", border: "border-amber-500/30" },
  approved: { label: "Approved", color: "bg-emerald-500/10 text-emerald-400", border: "border-emerald-500/30" },
  published: { label: "Published", color: "bg-blue-500/10 text-blue-400", border: "border-blue-500/30" },
};

export const STATUS_ORDER = ["draft", "in_review", "approved", "published"];

export const isMultiSectionDraft = (draft, contentType) => {
  if (!draft) return false;
  if (MULTI_SECTION_TYPES.includes(contentType)) return true;
  const sectionMatches = draft.match(/\n###\s+/g);
  return sectionMatches && sectionMatches.length >= 2;
};

export const parseDraftToSections = (draft) => {
  const sections = {};
  const sectionNames = [];
  const parts = draft.split(/\n###\s+/);
  for (const part of parts.slice(1)) {
    const lines = part.split("\n");
    const name = lines[0].trim();
    const contentLines = [];
    for (const line of lines.slice(1)) {
      if (line.trim() === "---") break;
      contentLines.push(line);
    }
    const content = contentLines.join("\n").trim();
    if (name && content) {
      sections[name] = content;
      sectionNames.push(name);
    }
  }
  if (sectionNames.length === 0) {
    sections["Full Content"] = draft;
    sectionNames.push("Full Content");
  }
  return { sections, section_names: sectionNames };
};
